import "./ResidentialProxy.scss";
import { useState } from "react";
import { TabsList } from "../../../../../components/common/TabsList/TabsList";
import { useTranslation } from "../../../../../hooks";
import { General } from "./components/General/General";
import { WhiteList } from "./components/WhiteList/WhiteList";
import { Statistic } from "./components/Statistic/Statistic";
import { History } from "./components/History/History";

export const ResidentialProxy = () => {
  const { cabinet: { orders: { residential: {
    general, whitelist, statistic, history
  } } } } = useTranslation();

  const tabs = [
    { value: "general", label: general },
    { value: "whitelist", label: whitelist },
    { value: "statistic", label: statistic },
    { value: "history", label: history }
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].value);

  return (
    <div className="residential">
      <div className="residential__tabs">
        <TabsList tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      <div className="residential__content">
        {activeTab === "general" && <General />}
        {activeTab === "whitelist" && <WhiteList />}
        {activeTab === "statistic" && <Statistic />}
        {activeTab === "history" && <History />}
      </div>
    </div>
  );
};
